import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { 
  FaCog, 
  FaBolt, 
  FaRoad, 
  FaHardHat, 
  FaTools,
  FaArrowRight 
} from 'react-icons/fa';
import { AppContext } from '../context/AppContext';
import Loader from '../components/common/Loader';
import './Services.css';

const Services = () => {
  const { services, loading } = useContext(AppContext);

  useEffect(() => {
    document.title = 'Our Services | Infrastructure Company';
  }, []);

  const serviceIcons = {
    'Underground Cable Wiring': <FaCog />,
    'Electricity Meters Installation': <FaBolt />,
    'Road Construction': <FaRoad />,
    'Road Building': <FaHardHat />,
    'Underground Related Works': <FaTools />
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="services-page">
      {/* Page Header */}
      <section className="page-header">
        <Container>
          <div className="text-center">
            <h1 className="display-4 fw-bold mb-3">Our Services</h1>
            <p className="lead">
              Comprehensive Infrastructure Solutions for Modern India
            </p>
          </div>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="section">
        <Container>
          {services && services.length > 0 ? (
            <Row className="g-4">
              {services.map((service) => (
                <Col key={service._id} md={6} lg={4}>
                  <Card className="service-detail-card h-100">
                    <div className="service-card-icon">
                      {serviceIcons[service.title] || <FaCog />}
                    </div>
                    <Card.Body className="p-4">
                      <h3 className="mb-3">{service.title}</h3>
                      <p className="text-muted mb-4">{service.shortDescription}</p>
                      
                      {service.features && service.features.length > 0 && (
                        <ul className="service-features mb-4">
                          {service.features.slice(0, 4).map((feature, index) => (
                            <li key={index}>
                              <FaArrowRight className="feature-icon" />
                              {feature}
                            </li>
                          ))}
                        </ul>
                      )}

                      <Button 
                        as={Link} 
                        to={`/services/${service.slug}`}
                        variant="primary"
                        className="w-100"
                      >
                        Learn More
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center py-5">
              <h3 className="text-muted">No services available at the moment</h3>
              <p className="text-muted">Please check back later</p>
            </div>
          )}
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <Container>
          <div className="text-center text-white">
            <h2 className="fw-bold mb-4">Need a Custom Solution?</h2>
            <p className="lead mb-4">
              Contact us for tailored infrastructure solutions for your specific needs
            </p>
            <Button as={Link} to="/contact" size="lg" className="btn-white">
              Get in Touch
            </Button>
          </div>
        </Container>
      </section>

      {/* Indian Accent */}
      <div className="indian-accent"></div>
    </div>
  );
};

export default Services;